interface UserStatsBarProps {
  total: number;
  activeCount: number;
  suspendedCount: number;
  blockedCount: number;
  pendingCount: number;
  verifiedCount: number;
  unverifiedCount: number;
}

export default function UserStatsBar({
  total,
  activeCount,
  suspendedCount,
  blockedCount,
  pendingCount,
  verifiedCount,
  unverifiedCount,
}: UserStatsBarProps) {
  const stats = [
    { label: 'Total', value: total, accent: 'bg-foreground-50 text-foreground-700 border-foreground-200' },
    { label: 'Activos', value: activeCount, accent: 'bg-green-50 text-green-700 border-green-200' },
    { label: 'Suspendidos', value: suspendedCount, accent: 'bg-amber-50 text-amber-700 border-amber-200' },
    { label: 'Bloqueados', value: blockedCount, accent: 'bg-red-50 text-red-700 border-red-200' },
    { label: 'Pendientes', value: pendingCount, accent: 'bg-blue-50 text-blue-700 border-blue-200' },
    { label: 'Verificados', value: verifiedCount, accent: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
    { label: 'No Verificados', value: unverifiedCount, accent: 'bg-slate-50 text-slate-700 border-slate-200' },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2">
      {stats.map((s) => (
        <div
          key={s.label}
          className={`flex items-center gap-2 px-3 py-2 rounded-xl border ${s.accent} min-w-[100px]`}
        >
          <span className="text-[10px] font-semibold uppercase tracking-wider opacity-70">{s.label}</span>
          <span className="text-sm font-bold ml-auto">{s.value}</span>
        </div>
      ))}
    </div>
  );
}